import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ZuiMaterialStackModule } from '@zerops/zui/material-stack';
import { SatPopoverModule } from '@zerops/zef/popover';
import { UserDataEditFormModule } from '@zerops/zui/user-data-edit-form';
import { FormSectionModule } from '@zerops/zui/form-section';
import { ZefProgressErrorModule } from '@zerops/zef/progress-error';
import { PopStateModule } from '@zerops/zui/pop-state';
import { UserDataFieldsModule } from '@zerops/zui/user-data-fields';
import { TranslocoModule } from '@ngneat/transloco';
import { UserDataEditPopComponent } from './user-data-edit-pop.component';

@NgModule({
  declarations: [ UserDataEditPopComponent ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ZuiMaterialStackModule,
    SatPopoverModule,
    UserDataEditFormModule,
    FormSectionModule,
    ZefProgressErrorModule,
    PopStateModule,
    TranslocoModule,
    UserDataFieldsModule
  ],
  exports: [ UserDataEditPopComponent ]
})
export class UserDataEditPopModule {

}
